const styles = {
  draft: "bg-orange-50 text-orange-700 ring-orange-200",
  sent: "bg-sky-50 text-sky-700 ring-sky-200",
  approved: "bg-green-50 text-green-700 ring-green-200",
  declined: "bg-red-50 text-red-700 ring-red-200",
  scheduled: "bg-sky-50 text-sky-700 ring-sky-200",
  in_progress: "bg-amber-50 text-amber-700 ring-amber-200",
  completed: "bg-green-50 text-green-700 ring-green-200",
  cancelled: "bg-zinc-100 text-zinc-500 ring-zinc-200",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId || `status-badge-${status}`}
    className={`inline-flex items-center rounded px-2 py-0.5 font-mono text-[11px] font-semibold uppercase tracking-wider ring-1 ring-inset ${styles[status] || styles.draft}`}>
    {status?.replace("_", " ")}
  </span>
);
